import { render, staticRenderFns } from "./CommodityCodeSlect.vue?vue&type=template&id=24f0096e&"
import script from "./CommodityCodeSlect.vue?vue&type=script&lang=js&"
export * from "./CommodityCodeSlect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports